import apiAxios from '@/apiAxios.js'

import BudgetAdjustView from '../BudgetAdjustRequest/sub/BudgetAdjustView/BudgetAdjustView.vue'

export default {
  props: {
    formId: String,
  },
  components: { BudgetAdjustView },
  data() {
    return {
      layoutConfig: {
        titleLeft: '待审批列表',
        titleRight: '调整单详情',
        emptyName: '调整单',
      },

      editItem: null,
      rightIsLoading: true,
      listIsLoading: true,

      popEditTitle: '',
      popEditVisible: false,
      popEditItem: null,
      no: '',
      taskId: '',

      queryResult: {
        content: [],
      },
      queryParams: {
        limit: 50,
        page: 1,
        value: '',
        documentTypeId: this.formId,
        sourceType: 'BudgetAdjustRequest',
        companyId: '',
        companyName: '',
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    async approveSubmit() {
      const { data } = await apiAxios.post(
        `em/budgetAdjustRequest/approve`,
        this.popEditItem
      )
      this.$message.success(data.message)
      await this.cancelEdit()
      await this.loadData()
    },

    approveEvent(agree) {
      this.popEditTitle = agree ? '(审批通过)批注' : '(审批拒绝)批注'
      this.popEditVisible = true
      this.popEditItem = {
        taskId: this.taskId,
        requestId: this.no,
        agree: agree,
        comment: '',
      }
    },

    cancelEdit() {
      this.popEditTitle = ''
      this.popEditVisible = false
      this.popEditItem = null
    },

    async handleClickOne(item) {
      this.rightIsLoading = true
      const { data } = await apiAxios.get(
        `/em/budgetAdjustRequest/${item.businessInfo.id}`
      )
      this.editItem = data.result
      this.rightIsLoading = false
      this.taskId = item.taskId
      this.no = item.businessInfo.no
    },

    async loadData() {
      this.listIsLoading = true
      this.queryResult = {}
      this.editItem = null
      const serverQueryParams = Object.assign({}, this.queryParams)
      serverQueryParams.page -= 1 // 服务器从0开始计数
      const { data } = await apiAxios.get(`/em/bpm/todo`, {
        params: serverQueryParams,
      })
      this.queryResult = data.result
      this.listIsLoading = false
    },
  },
  async mounted() {
    await this.loadData()
  },
}
